import { request as sonataRequest } from 'sonata-react-components';

export type BulkOperationResult = {
  error?: string;
  id: string;
  success: boolean;
};

export const syncLineItem = (lineItemId: string): Promise<Record<string, any>[]> => {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}campaign/syncCampaign/${lineItemId}`, {
    method: 'POST'
  });
};

export const bulkDeleteLineItems = (ids: string[]): Promise<{ results: BulkOperationResult[] }> => {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}campaign/bulkDelete`, {
    data: { ids },
    method: 'POST'
  });
};

export const bulkDuplicateLineItems = (ids: string[]): Promise<{ results: BulkOperationResult[] }> => {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}campaign/bulkDuplicate`, {
    data: { ids },
    method: 'POST'
  });
};

export const getAsyncProcesses = (userId: string, lineItemId: string): Promise<Record<string, any>[]> => {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}campaign/${userId}/asyncProcesses`, {
    data: {
      cid: lineItemId
    },
    method: 'POST'
  });
};
